import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import { useLocation } from "react-router-dom";

import ExpenseUpdateChild from "./ExpenseUpdateChild";

const ExpenseUpdate = () => {
  const { state } = useLocation();
  const expenseRecord = state;
  return (
    <MainTemplate>
      <CardBackground>
        <ExpenseUpdateChild expenseRecord={expenseRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default ExpenseUpdate;
